import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { addPackProposal, fetchMyPacks, fetchSinglePack, getAllPacksForBrandApi, updatePackApi } from 'api/packApi';

import { setCreatorPacksData } from 'states/creatorDetails/creatorDetailsSlice';
import { setSinglePackData } from 'states/packDetails/packDetailsSlice';

// Pack Action: Edit | Update
export const UpdatePack = createAsyncThunk(
  "pack/update",
  async ({ header, formData }, { rejectWithValue }) => {
    try {
      const response = await updatePackApi(header, formData); // Using the API function

      // Return the response from API
      return response;
    } catch (error) {
      // Handle error if the API fails
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data); // Custom error from backend
      } else {
        return rejectWithValue(error); // Fallback to default error
      }
    }
  }
);

// Fetch all packs for a brand
export const getAllPacksForBrandCall = createAsyncThunk(
  'packs/getPacks',
  async ({ token, data, page }, { rejectWithValue, dispatch }) => {
    try {
      // Check if the role is brand, not creator
      // This check should ideally be handled on the backend side, but you can do it here as well if needed.
      const response = await getAllPacksForBrandApi(token, data, page);
      dispatch(setCreatorPacksData(response?.data?.data)); // Dispatch packs data to Redux store
      return response;
    } catch (error) {
      // If there's an error, return custom error message from the backend if present
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(error);
      }
    }
  }
);

// Fetch my packs with filters (async thunk)
export const getMyPacks = createAsyncThunk(
  "myPacks/getMyPacks",
  async ({ token, data, dropdownOpen, page }, { rejectWithValue, dispatch }) => {
    try {
      const response = await fetchMyPacks({ token, data, page });
      dropdownOpen(); // Execute dropdownOpen callback after data is fetched
      // If you want to store the response in your Redux state, you can dispatch a reducer action here
      // Example: dispatch(setPacks(response?.data?.data));
      return response;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data); // Return error from backend if present
      } else {
        return rejectWithValue(error.message || "An unknown error occurred");
      }
    }
  }
);

// Fetch single pack details (async thunk)
export const getSinglePackCall = createAsyncThunk(
  "packDetails/getSinglePack",
  async ({ token, data }, { rejectWithValue, dispatch }) => {
    try {
      const response = await fetchSinglePack({ token, data });
      dispatch(setSinglePackData(response)); // Dispatch an action to store the pack details
      return response;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data); // Return error from backend if present
      } else {
        return rejectWithValue(error.message || "An unknown error occurred");
      }
    }
  }
);

// Create AsyncThunk for adding a new pack proposal
export const addPack = createAsyncThunk(
  "addPack/addNewPack", // Action type
  async ({ token, formData, navigate, setFiles }, { rejectWithValue, dispatch }) => {
    try {
      const response = await addPackProposal(token, formData); // Call the API function

      // Navigate to the view packs page
      navigate("/packs/view");

      // Clear the uploaded files
      setFiles([]);

      return response; // Return the response data
    } catch (error) {
      // Show an error toast message if the request fails
      toast.error("Failed to add the new pack, please try again later!");

      // Check for error response and reject with custom error message
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(error);
      }
    }
  }
);
